module.exports = __webpack_public_path__ + "pic1.6de00caf552e2182f2da.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic1.jpg
// module id = ../../../../../src/assets/img/pic1.jpg
// module chunks = main